import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../store";
import { startSignalR, stopSignalR } from "./manager"; // o da action-creators/signalR

type Props = {
  children: React.ReactNode;
};

export const SignalRProvider: React.FC<Props> = ({ children }) => {
  const dispatch = useDispatch();
  const jwt = useSelector((s: AppState) => s.token);

  useEffect(() => {
    if (!jwt) return;

    dispatch(startSignalR(jwt));

    return () => {
      dispatch(stopSignalR());
    };
  }, [jwt, dispatch]);

  return <>{children}</>;
};
